import React, { Component } from "react";
import CustomToast from "components/notifications/CustomToast";
import { store } from "redux/store";
import { logoutAndClearSession } from "redux/auth/logoutAndClearSession";

class Toaster extends Component {
  state = {
    editedData: null,
    toast: false,
    toastify: {}
  };

  normalizeMessage = value => {
    if (value == null || value === false) return "";
    if (typeof value === "string" || typeof value === "number")
      return String(value);
    if (typeof value === "object") {
      // Axios error
      if (value.response?.data?.message != null) {
        return this.normalizeMessage(value.response.data.message);
      }
      // Axios response passed by mistake (error.response)
      if (value.data?.message != null) {
        return this.normalizeMessage(value.data.message);
      }
      if (typeof value.message === "string") return value.message;
      try {
        return JSON.stringify(value);
      } catch (e) {
        return "Something went wrong.";
      }
    }
    return String(value);
  };

  error = error => {
    let message = "Something went wrong.";
    if (error && error.response) {
      // Full Axios error
      message = this.normalizeMessage(
        error.response.data?.message || error.response.data || message
      );
    } else if (error && error.data) {
      // Axios response mistakenly passed as error.response
      message = this.normalizeMessage(
        error.data?.message || error.data || message
      );
    } else {
      message = this.normalizeMessage(error) || message;
    }

    // Final safety: never put a non-string into toast state
    if (typeof message !== "string") {
      message = this.normalizeMessage(message) || "Something went wrong.";
    }

    this.setState({
      toast: true,
      toastify: {
        message,
        styleClass: "c-danger"
      }
    });

    const status =
      (error && error.response && error.response.status) ||
      (error && error.status);
    if (status === 401) {
      store.dispatch(logoutAndClearSession());
    }
    setTimeout(() => {
      this.setState({ toast: false });
    }, 2000);
  };

  success = message => {
    this.setState({
      toast: true,
      toastify: {
        message: this.normalizeMessage(message),
        styleClass: "c-success"
      }
    });
    setTimeout(() => {
      this.setState({ toast: false });
    }, 2000);
  };

  info = message => {
    this.setState({
      toast: true,
      toastify: {
        message: this.normalizeMessage(message),
        styleClass: "c-dark"
      }
    });
    setTimeout(() => {
      this.setState({ toast: false });
    }, 2000);
  };

  render() {
    const { toastify, toast } = { ...this.state };
    return (
      <CustomToast
        width={400}
        show={toast}
        transition={true}
        position="top-right"
        className={toastify && toastify.styleClass}
        message={toastify && toastify.message}
        onCloseCLick={() => this.setState({ toast: false })}
      />
    );
  }
}

export default Toaster;
